<template>
  <div id="app">
    <el-container>
       <!-- 头部 -->
      <el-header>
          <bsk-header></bsk-header>
      </el-header>


      <!-- router控制的内容区 -->
      <Loading v-if="updateLoadingState"></Loading>
      <el-main>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </el-main>

      <!-- 尾部 -->
      <bsk-footer></bsk-footer>

      <!-- 右侧悬浮栏 -->
      <aside-panel></aside-panel>

    </el-container>
  </div>
</template>

<script>
import "babel-polyfill";
import urls from './common/js/urls.js'
import BskHeader from './components/Layout/bskHeader.vue'
import BskFooter from './components/Layout/bskFooter.vue'
import Loading from './components/Layout/Loading.vue'
import AsidePanel from './components/Layout/AsidePanel.vue'
import { api_content_page_nav } from "./networks/ContentOperationHandler"

export default {
  name: 'app',
  data() {
      return {
        index_nav: [],
        isLoading: false,
      }
    },
  components:{
    BskHeader,
  	BskFooter,
    Loading,
    AsidePanel,
  },
  computed:{
    updateLoadingState(){
       return this.$store.state.isLoading
    }
  },
  created: function() {
       var context = this;
       var domain = window.location.host;
       if(domain=='runyu.winlesson.com'||domain=='www.runyubisheng.com'){
       // if(domain=='localhost:8080'){
          var application_id = 300;
          context.$store.dispatch('update_application', application_id);
       }else{
          var application_id = 1;
          context.$store.dispatch('update_application', application_id);
       }
        //1.请求网络层
        // var promise = api_content_page_nav(context);
        // //2.更新返回数据
        // promise.then(function(index_nav) {
        //     context.$store.commit('setIndexNav', index_nav);
        // }).catch(function(error){
        //     console.error(error);
        // });
    },
    mounted: function() {
      this.$store.commit('keep_user_login')
    }
}
</script>

<style>
#app{
 background-color: #f5f5f5;
}

body{
  margin:0;
  font-family: "PingFangSC-Regular","PingFang SC", "Microsoft YaHei", "微软雅黑";
  min-width: 1256px;

}
.a{
  text-decoration: none;
}
.el-main{
  padding:20px !important;
  padding-top: 68px !important;
  padding-bottom: 30px !important;
  background-color: #f5f5f5;
  min-height: 550px;
  width: 1278px!important;
  margin-right: auto;
  margin-left: auto;
}
.el-card{
  cursor: pointer;
}
.el-header {
  width: 100%;
  height: 72px!important;
  background-color: #fff;
  padding: 0!important;
  position: fixed;
  z-index: 99;
}

.doyoo_f_chat{
  box-shadow: 0px !important;
}


#doyoo_f_chat{
  box-shadow: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue